var _ellipse, _rect, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEsquerdaFrontal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 50,
    cy: 50,
    rx: 40,
    ry: 25,
    fill: "#fff",
    stroke: "#1976d2",
    strokeWidth: 3
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 35,
    width: 20,
    height: 30,
    fill: "#90caf9",
    opacity: 0.7
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 30,
    y: 75,
    fontSize: 12,
    textAnchor: "middle",
    fill: "#1976d2"
  }, "Esq. Frontal")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsquerdaFrontal);
export default __webpack_public_path__ + "static/media/esquerda-frontal.8fdfa08b33adb30d484a05bdef76d67b.svg";
export { ForwardRef as ReactComponent };